export default function() {
  return {
    template: require('./new-cc-form.jade'),
    controller: ['$scope', function($scope) {

    }]
  };
}
